import { CandidateInputsTooltipTitle } from '@taxonomy-translation/components'
import { Tooltip } from '@components/tooltip/tooltip'

export const HeaderTooltip = ({
  inputNames,
  children,
}: {
  inputNames: string[]
  children: React.ReactNode
}) => (
  <Tooltip title={<CandidateInputsTooltipTitle names={inputNames} />}>
    <div className="relative">
      <span className="colHeader columnSorting sortAction">{children}</span>
    </div>
  </Tooltip>
)
